import React from "react";
import "./FourthSector.css";

import img2 from "../../../assets/images/img2.jpeg";

const FourthSector = () => {
  return (
    <section className="texto-imagen-fourth">
      <div className="texto-fourth-sector">
        <p>
        Thorne Global Real Estate es la primer Compañía de habla hispana enfocada al asesoramiento personalizado de inversores residentes o no residentes de UAE, que tengan por fin invertir en bienes raíces, donde si bien abundan los proyectos extremadamente lujosos y rascacielos impresionantes, existe también otro mercado sumamente interesante para aquellos que desean hacer una inversión más conservadora; pero teniendo como principal objetivo siempre el acompañamiento de nuestros inversores en todo su recorrido y experiencia de invertir en Dubai y otros Emiratos.
        </p>
      </div>
      <div className="imagen">
        <img src={img2} alt="Imagen2" />
      </div>
    </section>
  );
};

export default FourthSector;